<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="toolBar">

      <van-dropdown-menu>
        <van-dropdown-item v-model="search.sort" :options="optionSort" @change="onSearch" />
        <van-dropdown-item v-model="search.type" :options="optionType" @change="onSearch" />
      </van-dropdown-menu>
    </div>
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.insuranceProductId" class="dataLine" @click="onSelectItem(item.insuranceProductId)">
          <div class="imgs">
            <van-image
              width="6em"
              height="4em"
              lazy-load
              fit="cover"
              :src="item.smaillImage"
            />
          </div>
          <div class="body">
            <div class="title"> {{ item.name }}{{ item.planName }}</div>
            <div class="tags">
              <van-tag v-for="(value,index) in item.tagList" :key="index" plain type="primary" :color="GetColorMainBack()">{{ value }}</van-tag>
            </div>
            <div class="price" :style="'color:'+GetColorMainBack()"><span>￥</span>{{ ShowMoneySpan(item.priceFee*0.01,true) }}.<span>{{ ShowMoneySpan(item.priceFee*0.01,false) }}</span></div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="downAbout">本平台产品为深圳市慧择保险经纪有限公司提供投保链接<br>相应保险服务、保全、理赔协助由深圳市慧择保险经纪有限公司提供</div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, DropdownMenu, DropdownItem, Tag, Image, Lazyload, List } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoneySpan, getUserBase, ShowMoney, GetEnumText, GetEnumList, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '保险列表',
      backurl: '/store/index',
      search: {
        limit: 30,
        page: 1,
        type: 'All',
        sort: 'Default'
      },
      loading: undefined,
      finished: false,
      list: [],
      optionType: [],
      optionSort: [],
      paramsType: undefined,
      paramsTypeId: undefined
    }
  },
  activated() {
    this.paramsType = getUrlKey('type')
    this.paramsTypeId = getUrlKey('typeid')
    var diveType = getUrlKey('diveType')
    if (diveType) {
      this.search.type = diveType
    } else {
      this.search.type = 'All'
    }
  },
  created() {
    getUserBase(() => {
      this.optionType = GetEnumList('Em_InsuranceProduceSearchType')
      this.optionSort = GetEnumList('Em_InsuranceProduceSearchSortType')
      this.titleTop = GetSysTitle()
    }, true)
  },
  methods: {
    ShowMoneySpan,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onSearch() {
      console.log('onSearch', this.search)
      this.init()
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      console.log('onLoad')
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/Insurance/GetInsuranceProductList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          if (item.tag) {
            item.tagList = item.tag.split(',')
          } else {
            item.tagList = []
          }
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onSelectItem(id) {
      var url = '/insurance/info/' + id
      if (this.paramsTypeId && this.paramsType) {
        url += '?type=' + this.paramsType + '&typeid=' + this.paramsTypeId
      }
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.toolBar{
  position: fixed;
  top:3em;
  left: 0;
  right: 0;
  z-index: 10;
}
.dataRect{
  padding-top: 3em;
}
.dataRect .dataLine{
  min-height: 4em;
  border-bottom:1px solid #f5f5f5;
  padding: 0.5em 1em;
  background-color: #fff;
  position: relative;
}
.dataRect .dataLine .imgs{
  position: absolute;
  left: 1em;
  top: 0.5em;
}
.dataRect .dataLine .body{
  padding-left: 6.5em;
}
.dataRect .dataLine .body .title{
  font-size: 0.9em;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.dataRect .dataLine .body .price{
  font-size: 1.2em;
  line-height: 1.6em;
}
.dataRect .dataLine .body .price span{
  font-size: 0.5em;
}
.dataRect .tags{
  padding-left: 0.1em;
  overflow: hidden;
  max-height: 2.6sem;
}
.dataRect .tags span{
  margin-right: 0.5em;
  margin-bottom: 0.25em;
}
.downAbout{
  padding: 5em;
  font-size: 0.35em;
  color: #999;
  text-align: center;
  background-color: #fff;
}
</style>
